import { FormArray, FormGroup } from "@angular/forms";
import { Hoist } from "../../../models/hoist.model";
import { logTimeOf } from "../../../flights2.pipes";
import { amount, hours, id } from "../../form/controls";

/** What this flight used of a hoist: its cycles and hours, never its totals. */
export function buildHoistArray(hoists: Hoist[]) {
    return new FormArray(hoists.map((hoist) => new FormGroup({ id: id(hoist.id), cycles: amount(hoist.cycles), hours: hours(logTimeOf(hoist.hours) || null) })));
}

export type HoistArray = ReturnType<typeof buildHoistArray>;
